import { IState } from "types/redux";

export const getMenuOpen = ({ responsive }: IState): boolean => responsive.menuOpen

export const getSidebarOpen = ({ responsive }: IState): boolean => responsive.sidebarOpen